// TODO: Move this to selectors
export const getFixedLineTariffLabel = landlineTariff => {
  if (!landlineTariff || !landlineTariff.name) return ''

  const [fixedLineTypeName] = landlineTariff.name.split(/( \+.*)/)

  return fixedLineTypeName
}
